import React from 'react'
import { CCard, CCardHeader, CCardBody, CCardTitle, CCardFooter, CButton, CRow, CCol, CDropdownToggle, CDropdown, CDropdownItem, CDropdownDivider, CDropdownMenu } from '@coreui/react'
import { cilPencil, cilTrash } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { BsTrash3, BsPencil, BsHighlighter } from 'react-icons/bs'
import { HiDotsVertical } from "react-icons/hi";
import { Highlighter } from 'lucide-react'

const Carder = ({ showEditDelete = true, className, deleteFunc, editFunc, EditHighlightFunc, children, ...props }) => {
    const { title } = props
    return (
        <CCard className={'carder-oultine border mt-3 p-0 m-0'}>
            <CRow className='mx-0'>
                <CCol xs={showEditDelete ? 10 : 12} className='px-0'>
                    {children}
                </CCol>
                {showEditDelete && (editFunc || deleteFunc || EditHighlightFunc) && (
                    <CCol xs={2} className='d-flex align-items-start justify-content-end px-2 py-2'>
                        <CDropdown>
                            <CDropdownToggle size="sm" color="transparent" caret={false} className='btn-dropdown-remove-bg border-0'>
                                <HiDotsVertical />
                            </CDropdownToggle>
                            <CDropdownMenu className='dropdown-menu-box'>
                                {editFunc && (
                                    <CDropdownItem onClick={editFunc} className='dropdown-items-custom d-flex align-items-center gap-2'>
                                        <BsPencil /> <p className='p-0 m-0'>Edit</p>
                                    </CDropdownItem>
                                )}

                                {EditHighlightFunc && (
                                    <CDropdownItem onClick={EditHighlightFunc} className='dropdown-items-custom d-flex align-items-center gap-2'>
                                        <BsHighlighter /> <p className='p-0 m-0'>Edit Highlights</p>
                                    </CDropdownItem>
                                )}
                                {deleteFunc && (
                                    <CDropdownItem onClick={deleteFunc} className='dropdown-items-custom d-flex align-items-center gap-2'>
                                        <BsTrash3 /> <p className='p-0 m-0'>Delete</p>
                                    </CDropdownItem>
                                )}
                            </CDropdownMenu>
                        </CDropdown>
                    </CCol>
                )}
            </CRow>
        </CCard>
    )
}

export default Carder